/**
 * Brand status color for a gift-card status badge. Single source of truth so
 * every surface (the Credits-tab card list, the attach modal, …) renders the
 * same status in the same color. Accepts any casing; unknown statuses fall back
 * to gray.
 */
export const giftCardStatusColor = (status: string): string => {
  switch (status.toLowerCase()) {
    case "active":
      return "var(--brand-lime-green)";
    case "voided":
      return "red";
    case "depleted":
    case "expired":
      return "gray";
    default:
      return "gray";
  }
};
